import { createAction } from 'signin-app/redux/helpers';
const domain = 'CHILD_CHECKIN_IN';
export const { action: selectPickupRelation } = createAction(`${domain}/SELECT_PICKUP_RELATION`, (relationId) => ({ relationId }));
export const { action: selectPickupHours } = createAction(`${domain}/SELECT_PICKUP_HOURS`, (hours) => ({ hours }));
export const { action: selectPickupMinutes } = createAction(`${domain}/SELECT_PICKUP_MINUTES`, (minutes) => ({
    minutes,
}));
export const { action: resetPickup } = createAction(`${domain}/RESET_PICKUP`, () => null);
export const { action: checkInChild, success: checkInChildSuccess, failed: checkInChildFailed, } = createAction(`${domain}/CHECKIN`, (options) => ({ options }), (response, pickupName) => ({ response, pickupName }), (error) => ({ error }));
export const { action: addNewPickupRelation } = createAction(`${domain}/NEW_PICKUP_RELATION`, (addNew, pickupPersonName) => ({
    addNew,
    pickupPersonName,
}));
